/*
 * @Description:
 * @Author: lz
 * @Date: 2021-09-06 11:33:38
 * @LastEditTime: 2021-09-09 15:57:45
 * @LastEditors: lz
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    count: 0
  },
  mutations: {
    UPDATE_USERINFO(state, userInfo) {
      state.userInfo = userInfo
    },
    UPDATE_COUNT(state, count) {
      state.count = count
    }
  },
  actions: {},
  modules: {},
  getters: {
    userInfo: (state) => state.userInfo,
    count: (state) => state.count
  }
})
